import React from "react";

const PlusIcon = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3125 11.8125H15.1875V1.6875C15.1875 1.23995 15.0097 0.810725 14.6932 0.494258C14.3768 0.17779 13.9476 0 13.5 0C13.0524 0 12.6232 0.17779 12.3068 0.494258C11.9903 0.810725 11.8125 1.23995 11.8125 1.6875V11.8125H1.6875C1.23995 11.8125 0.810725 11.9903 0.494258 12.3068C0.17779 12.6232 0 13.0524 0 13.5C0 13.9476 0.17779 14.3768 0.494258 14.6932C0.810725 15.0097 1.23995 15.1875 1.6875 15.1875H11.8125V25.3125C11.8125 25.7601 11.9903 26.1893 12.3068 26.5057C12.6232 26.8222 13.0524 27 13.5 27C13.9476 27 14.3768 26.8222 14.6932 26.5057C15.0097 26.1893 15.1875 25.7601 15.1875 25.3125V15.1875H25.3125C25.7601 15.1875 26.1893 15.0097 26.5057 14.6932C26.8222 14.3768 27 13.9476 27 13.5C27 13.0524 26.8222 12.6232 26.5057 12.3068C26.1893 11.9903 25.7601 11.8125 25.3125 11.8125Z"
        fill="white"
      />
    </svg>
  );
};

export default PlusIcon;
